export default {
  ACTIVATE_SOWOS_MODERATE_COMMAND: Symbol.for('ACTIVATE_SOWOS_MODERATE_COMMAND'),
  ACTIVATE_SOWOS_MODERATE_REPOSITORY: Symbol.for('ACTIVATE_SOWOS_MODERATE_REPOSITORY'),
};
